module.exports = "/_next/static/images/kit-phone-velieve@2x-min-d4172d9d2ed450933700f6ddf3cd2f4a.png";